export default __webpack_public_path__ + "static/media/001-sun.4b3a2948.svg";